{
  "APP_NAME": "followup-frontend",
  "About": "About",
  "Hello world !": "Hello world !",
  "Home": "Home",
  "Cancel": "Cancel",
  "Change language": "Change language",
  "Language": "Language",
  "Ok": "Ok",
  "Login": "Login",
  "Logout": "Logout",
  "Password": "Password",
  "Password is required": "Password is required",
  "Username": "Username",
  "Username is required": "Username is required",
  "Username or password incorrect.": "Username or password incorrect.",
  "Remember me": "Remember me",
  "Version": "Version"
}
